/**
 * @hidden
 */
export var normalize = function () {
    var _a;
    var settings = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        settings[_i] = arguments[_i];
    }
    return (_a = Object).assign.apply(_a, [{ allowUnsort: true, mode: 'single' }].concat(settings));
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-vue-grid/dist/es/interfaces/GridSortSettings.js
// module id = null
// module chunks = 